query GetEditionStatus($editionId: ID!) {
    edition(id: $editionId) {
        id
        status
    }
}
